import ClasImpl from '@/serviceImpl/ClasImpl';
import {Precinct} from '@/domain/entities/Precinct';
import {getCredentialsOrThrow} from '@/domain/useCases/getCredentialsOrThrow';

const editNewPrecinctUseCase = async (newPrecinct: Partial<Precinct>): Promise<Partial<Precinct> | undefined> => {
  const accessToken = getCredentialsOrThrow();

  try {
    return await ClasImpl.editPrecinct(newPrecinct, accessToken);
  } catch (error) {
    console.error('Error fetching projects', error);
    throw error;
  }

};

export default editNewPrecinctUseCase;